import { customSeriesDefaultOptions, } from 'lightweight-charts';
export const defaultOptions = Object.assign(Object.assign({}, customSeriesDefaultOptions), { lineWidth: 2 });
